import { ca } from '@cian/analytics';

export enum EBlockName {
  Useful = 'Useful',
  PickUpProduct = 'PickUpProduct',
  Models = 'Models',
  Reports = 'Reports',
  Publications = 'Publications',
  Form = 'Form',
}

export function trackViewBlock(label: EBlockName) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'B2BLanding',
    action: 'Scroll',
    label,
  });
}
